export const MARK_TYPE = {
    OMIT: 'omit',
    INSERT: 'insert',
    SUBSTITUTE: 'substitute',
    REPEAT: 'repeat',
    SELF_CORRECT: 'self-correct',
    CORRECT: 'correct',
};

export const RANGE_MARK_TYPES = [
    MARK_TYPE.REPEAT,
    MARK_TYPE.SELF_CORRECT,
    MARK_TYPE.OMIT,
    MARK_TYPE.CORRECT,
];
export const ANNOTATION_MARK_TYPES = [MARK_TYPE.INSERT, MARK_TYPE.SUBSTITUTE];

export const EVENT_TYPES = {
    USER_EVENT: 'user',
    VR_EVENT: 'vr',
};
